import React, { useContext } from 'react';
import { RequestAccessGlobalWorkflowContext } from '../contexts/RequestAccessGlobalWorkflowContext';
import { ButtonModalAccess } from './button/ButtonModalAccess';
import { Loading } from 'common/components/Loading';
import { ButtonIAMAccess, canUseIAMWidget } from './button/ButtonIAMAccess';
import { useUser } from '../services/SgConnectService';

export const RequestAccessWidget: React.FC = () => {
  const { site, hasOnBehalfOf, onBehalfOf, widgetProps: { popsIdentifier } } = useContext(RequestAccessGlobalWorkflowContext);
  const { isInternal: isInternalUser } = useUser();

  if (!onBehalfOf.isFetching) {
    const isInternal = hasOnBehalfOf ? onBehalfOf.isInternal : isInternalUser;
    if (isInternal && canUseIAMWidget({ site })) {
      return <ButtonIAMAccess />;
    }

    if (site || popsIdentifier) {
      return <ButtonModalAccess />;
    }
  }

  return <Loading />;
};
